export const getElementPropertyValue = (element: Element, propertyName: string) =>
  getComputedStyle(element).getPropertyValue(propertyName);

export const getElementPropertyValueNumber = (element: Element, propertyName: string) =>
  Number(getElementPropertyValue(element, propertyName).replace(/\D/g, ''));
